import React from 'react';
import { handleFileDownload } from '../../../lib/utils';

const DownloadProcessButton = ({ downloadLink, status }) => {
    if (status !== 'completed' || !downloadLink) return null;

    return (
        <button
            className="btn btn-sm btn-primary-gradient text-white rounded-pill ms-2"
            onClick={handleFileDownload(downloadLink)}
        >
            <i className="bi bi-download me-2"></i>
            Download
        </button>
    );
};

export default DownloadProcessButton;
